import { Component, OnInit } from '@angular/core';
import { Related } from 'src/app/interfaces/related.interface';
import { RelatedService } from 'src/app/services/related.service';

@Component({
    selector: 'app-related-overlay',
    templateUrl: './related-overlay.component.html',
    styleUrls: ['./related-overlay.component.scss']
})
export class RelatedOverlayComponent implements OnInit {
    relatedOverlay: any;
    relatedOverlayQuick: any;
    loadOverlay: boolean = false;
    videotitleActive: boolean = false;
    loadOverlayQuick: boolean = false;
    videocontentActive: boolean = false;
    showOverlay: boolean = true;
    showOverlayQuick: boolean = true;

    constructor(private related: RelatedService) {
        this.related.returnRelatedOverlay().subscribe((resp) => {
            this.relatedOverlay = resp[0];
            this.loadOverlay = true;
            this.showOverlay = true;
            this.textActive();
        });
        this.related.removeOverlayListen().subscribe(() => {
            this.removeOverlay();
        });
    }

    ngOnInit(): void {
    }

    textActive() {
        setTimeout(() => {
            this.videotitleActive = true;
        }, 100);
        setTimeout(() => {
            this.videocontentActive = true;
        }, 350);
    }

    removeOverlay() {
        setTimeout(() => {
            this.showOverlay = false;
            this.loadOverlayQuick = false;
            setTimeout(() => {
                this.loadOverlay = false;
                this.loadOverlayQuick = false;
            }, 300);
        }, 500);
    }
    
    setOverlay(params) {
        this.relatedOverlayQuick = params;
        this.loadOverlayQuick = true;
        this.showOverlayQuick = true;
    }
}
